export default __webpack_public_path__ + "static/media/material-icons.ed0605a6.eot";